import { render, staticRenderFns } from "./CreateBrokerForm.vue?vue&type=template&id=7ae50f04&"
import script from "./CreateBrokerForm.vue?vue&type=script&lang=js&"
export * from "./CreateBrokerForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateBrokerForm.vue?vue&type=style&index=0&id=7ae50f04&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports